// extracted by mini-css-extract-plugin
export default {"container":"SmartBanner_container__u+iZd","image":"SmartBanner_image__wm8j1"};